<div class="wrapper">
    <header>
        <span class="header-assign">{{ 'access_control.list.assign' | translate }}</span>
        <button 
            mat-icon-button 
            aria-label="Close" 
            class="close-button mat-icon-button"
            [disabled]="loading"
            (click)="close()"
        >
            <span class="icon-close"></span>
        </button>
    </header>

    <!-- Role Details Section (shown when role is selected) -->
    <div class="role-details-section">
        <!-- Search and Assign New Users -->
        <div class="assign-users-section">
            <span class="search_user">{{ 'access_control.dialog.search_user' | translate }}</span>
            <app-search-dropdown
                [selectedUsers]="selectedUsers"
                [assignedUsersToRole]="assignedUsers"
                [roleId]="selectedRole?._id"
                (usersSelected)="onUsersSelected($event)"
                (noUsersFound)="onNoUsersFound($event)">
            </app-search-dropdown>
            
        </div>
    </div>

    <!-- Selected Users Preview -->
    <div class="selected-users-preview" *ngIf="selectedUsers.length > 0">
        <div class="user-chips-container">
          <app-user-chip
            *ngFor="let user of selectedUsers; trackBy: trackByUserId"
            [user]="user"
            [showRemove]="!loading"
            (remove)="removeSelectedUser($event)">
          </app-user-chip>
        </div>
      </div>

    <div class="role-selection-section" *ngIf="selectedUsers.length > 0">
        <h3>{{ 'access_control.dialog.select_role' | translate }}</h3>
        <app-role-selector
                [role]="assignableRoles"
                (selected)="onRoleSelectionChanged($event)">
        </app-role-selector>
    </div>

     <!-- No Users Found Section -->
    <div class="no-users-found-section" *ngIf="showNoUsersFound && selectedUsers.length === 0">
        <div class="no-users-message">
        <span class="no-users-text">{{ 'access_control.dialog.no_users_found' | translate }}</span>
        <button
            class="bciti-button bciti-button--black action-button"
            [routerLink]="['/user-create']"
            [disabled]="loading"
        >
            {{ 'access_control.dialog.create' | translate }}
        </button>
        </div>
    </div>

    <!-- Dialog Actions -->
    <mat-dialog-actions *ngIf="!showNoUsersFound && selectedUsers.length > 0">
        <button 
            class="bciti-button bciti-button--black-inversed action-button"
            [disabled]="loading"
            (click)="cancel()"
        >
            {{ 'access_control.dialog.cancel' | translate }}
        </button>
        <button 
            class="bciti-button bciti-button--black action-button"
            [disabled]="loading || selectedUsers.length === 0 || !roleIsSelected()"
            (click)="assignUsers()"
        >
            <div class="button-content">
                <mat-progress-spinner 
                    *ngIf="loading"
                    mode="indeterminate"
                    diameter="16"
                    color="accent"
                    class="inline-spinner">
                </mat-progress-spinner>
                <span *ngIf="!loading">
                    {{ 'access_control.list.confirm' | translate }}
                </span>
                <span *ngIf="loading">
                    {{ 'access_control.list.assigning' | translate }}
                </span>
            </div>
        </button>
    </mat-dialog-actions>
</div>